import React from 'react';
import '../less/benefits-military-personnel.less';
import top_img from '../img/top_img.webp';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import FAQStorybook from '@abank/abank-faq';
import { benefitsMilitaryPersonnelZakonLink } from '../../../../../services/urls/urls';

export default function template() {
  const questionsWidget = this.widgetsHelper.getWidgetFrom.call(this, 'widgets_2', 'questions');

  return (
    <div className="benefits-military-personnel">
      <div className="benefits-military-personnel__top">
        <div className="container">
          <div className="benefits-military-personnel__row">
            <img src={top_img} className="benefits-military-personnel__image" alt={this.l10n("SERVICES_BENEFITS_MILITARY_PERSONNEL_TITLE")} />
            <div className="benefits-military-personnel__left">
              <h1 className="benefits-military-personnel__title">{this.l10n("SERVICES_BENEFITS_MILITARY_PERSONNEL_TITLE")}</h1>
              <div className="benefits-military-personnel__text">
                {this.l10n("SERVICES_BENEFITS_MILITARY_PERSONNEL_TEXT")} <br/>
                <a {...getSafeLinkProps(benefitsMilitaryPersonnelZakonLink, {target: '_blank'})}>{this.l10n("SERVICES_BENEFITS_MILITARY_PERSONNEL_LINK")}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <QuestionsAdminNew
          widget={this.widgetsHelper.getWidget.call(this, 'questions')}
          showAll
          loader={this.state.loader}
          questionTag={"h2"}
        />
        <QuestionsAdminNew
          widget={questionsWidget}
          loader={this.state.widgets_2_loading}
          questionTag={"h3"}
          title={this.l10n("SERVICES_BENEFITS_MILITARY_PERSONNEL_QUESTIONS_TITLE")}
          toggleFaqTab={this.toggleFaqTab}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('SERVICES_BENEFITS_MILITARY_PERSONNEL_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('SERVICES_BENEFITS_MILITARY_PERSONNEL_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
    </div>
  );
}
